import { useEffect, useState } from "react";
import axios from "axios";
import "./azhome.css";
import { AzHero } from "./AzHero";
import { AzHeader } from "./AzHeader";
import { AzNews, AzListings } from "./AzNews";
import { AzMarkets } from "./AzMarkets";
import { AzWallet, AzStats, AzReferral, AzApp, AzCta } from "./AzPromos";
import { AzFooter } from "./AzFooter";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AzHome() {
  const [feed, setFeed] = useState(null);
  useEffect(() => { axios.get(`${API}/home/feed`).then((r) => setFeed(r.data)).catch(() => setFeed({})); }, []);
  return (
    <div className="az-home" data-testid="az-home">
      <AzHeader />
      <AzHero apps={feed?.apps} banners={feed?.banners} />
      <AzNews news={feed?.news || []} />
      <AzListings listings={feed?.listings || []} />
      <AzMarkets />
      <AzWallet />
      <AzStats stats={feed?.stats} />
      <AzReferral pct={feed?.referral_pct} />
      <AzApp apps={feed?.apps} />
      <AzCta />
      <AzFooter apps={feed?.apps} contact={feed?.contact} />
    </div>
  );
}
